__webpack_require__.p = "/political-spectrum/";